var _style, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCpoShield(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 38 32",
    style: {
      enableBackground: "new 0 0 38 32"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#1DC064;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M20.2,13.2c0-1.1-0.5-1.6-1.4-1.6h-1.1v3.2h1.1C19.7,14.9,20.2,14.3,20.2,13.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M27.5,11.6c-1.1,0-1.8,0.8-1.8,3.5c0,2.7,0.6,3.5,1.8,3.5c1.1,0,1.7-0.8,1.7-3.5 C29.2,12.4,28.6,11.6,27.5,11.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M1,1v12.6C1,23.6,9.1,31,19,31c0,0,0,0,0,0h0c9.9,0,18-7.4,18-17.4V1H1z M6.5,15.1c0-3.9,1.6-5.2,4-5.2 c2.2,0,3.6,1.2,3.7,3.6L12,13.9c-0.1-1.8-0.5-2.3-1.5-2.3c-1,0-1.7,0.8-1.7,3.5s0.6,3.5,1.7,3.5c0.9,0,1.4-0.6,1.5-2.3l2.2,0.5 c-0.2,2.4-1.6,3.6-3.7,3.6C7.9,20.3,6.5,19,6.5,15.1z M19,28c-4.5,0-8.4-1.8-11.2-4.7h22.3C27.4,26.2,23.5,28,19,28z M15.6,20.1 v-10h3.7c2.1,0,3.3,1.2,3.3,3.1c0,2-1.2,3.2-3.3,3.2h-1.5v3.7H15.6z M27.5,20.3c-2.5,0-4.1-1.5-4.1-5.2c0-3.7,1.5-5.2,4.1-5.2 c2.5,0,4.1,1.5,4.1,5.2C31.5,18.8,30,20.3,27.5,20.3z M34,7.5H4V4h30V7.5z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCpoShield);
export default __webpack_public_path__ + "static/media/cpo-shield.a0d58f069c7841cec27566944a455790.svg";
export { ForwardRef as ReactComponent };